import { Button, Td, Text, Tooltip, Tr } from '@chakra-ui/react';
import { CancelarLayout } from './CancelarLayout';

export const ItemLayout = ({ item }) => {
  return (
    <Tr fontSize="xs">
      <Td>{item.numero_pedido}</Td>
      <Td>{item.codigo_produto}</Td>
      <Td>{item.data_solicitacao}</Td>
      <Td>
        <Tooltip label={item.nome_produto} fontSize="md">
          <Text fontSize="sm" isTruncated maxW="150px" textTransform="capitalize">
            {item.nome_produto}
          </Text>
        </Tooltip>
      </Td>
      <Td>
        <Text textTransform="capitalize">{item.cor}</Text>
      </Td>
      <Td>
        <Text textTransform="capitalize">{item.tipo_personalizacao}</Text>
      </Td>
      <Td>{item.tipo_pedido}</Td>
      <Td>
        <Button
          as="a"
          href={item.link_logo}
          target="_blank"
          rel="noopener noreferrer"
          colorScheme="blue"
          size="sm">
          Link
        </Button>
      </Td>
      <Td>
        <CancelarLayout layout={item} />
      </Td>
    </Tr>
  );
};
